exports.baseURL = "https://newadmin.zekkolive.online/";
exports.key = "SjqWTaltdsBTeGseZXpujUloxZLEglIchxo0ginPhzc=";
exports.projectName = "zekkolive"
